import React, { useEffect, useState } from 'react';
import {
	BringzzPageContainer,
	BringzzIcon,
	BringzzText,
	BringzzImage,
	BringzzPostingCard,
	BringzzButton,
	BringzzModal
} from '@bringzz/components';
import { useNavigation } from 'context/NavigationContext';
import { useLocation } from 'react-router-dom';
import useRequest from 'hooks/useRequest';
import AvatarExample from 'assets/images/AvatarExample.png';
import PostExample1 from 'assets/images/PostExample1.png';
import { useTranslation } from 'react-i18next';
import useUser from 'hooks/useUser';
function useQuery() {
	return new URLSearchParams(useLocation().search);
}
let state = {
	checked: <div></div>,
	unChecked: <div></div>
};
const PostSuccess = () => {
	const { t } = useTranslation('posts');
	const { backPress } = useNavigation();
	let query = useQuery();
	const { sendRequest } = useRequest();
	const { getUser } = useUser();
	const { navigate } = useNavigation();
	let id = query.get('id');
	const [post, setPost] = useState(null);
	const [modalOpen, setModalOpen] = useState(false);

	return post && (
		<BringzzPageContainer
			header={{
				left: (
					<BringzzIcon
						size='22'
						icon='IconClose'
						folder='LineIcons'
						className='cursor-pointer'
						onClick={() => navigate('/')}
					/>
				),
			}}
		>
			<div className='p-4 flex flex-col space-y-4 h-full justify-center items-center'>
				<div className='flex-2 w-2/3 h-full' >
					<BringzzImage className='w-full' src='/images/default-image.png' alt='Image 1' />

				</div>
				<div className='flex-1 w-full h-full  justify-center items-center' >
					<BringzzText tag='h1' className='text-center'>
						{t('statusMessage.postStatus', { result: t(post.type == 3 ? 'success.scheduled' : 'success.published') })}
					</BringzzText>

				</div>
				<div className='flex-1 w-full h-full  justify-center items-center' >
					<BringzzText tag='h4' className='text-center font-thin'>
						{t('success.description')}
					</BringzzText>

				</div>
			</div>
		</BringzzPageContainer>
	);
};

export default PostSuccess;
